import { Box, Grid, Card, CardContent, } from "@mui/material";
import ChartBarTotalMp from "./components/chartBarTotalMP";
import ChartLineTotalCanal from "./components/chartLineTotalCanal";
import CardPeriodo from "./components/cardPeriodo";
import ListFatDetal from "./components/listFatDetal";
import { CanalDistribuicaoViewProps, mapDispatchToCanalDistribuicaoProps, mapStateToCanalDistribuicaoProps } from "../canalDist/canalDist.controll";
import { useEffect } from "react";
import { connect } from "react-redux";
import CardResumoMov from "./components/cardResumoMov";

function MainPanel(props: CanalDistribuicaoViewProps) {
    const { setFiltro } = props.canalDistribuicaoActions
    const { filtroMovCanal } = props.canalDistribuicaoState
    useEffect(() => {
        setFiltro(filtroMovCanal)
    }, [])
    return (
        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
            <Card sx={{ marginTop: 3 }}>
                <CardContent>
                    <Grid
                        container
                        spacing={2}
                        columns={12}
                        sx={{ mb: (theme) => theme.spacing(2) }}
                    >
                        <Grid size={{ xs: 12, md: 12 }}>
                            <CardPeriodo />
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <CardResumoMov filtro={filtroMovCanal}/>
                        </Grid>                        
                        <Grid size={{ xs: 12, md: 6 }}>
                            <ChartBarTotalMp />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <ChartLineTotalCanal />
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <ListFatDetal />
                        </Grid>

                    </Grid>
                </CardContent>
            </Card>
        </Box>

    )
}

export default connect(mapStateToCanalDistribuicaoProps, mapDispatchToCanalDistribuicaoProps)(MainPanel);